import { useState } from 'react';
import { validateEmail } from '@shared/utils';
import { FORM_MESSAGES } from '@shared/constants';
import { apiClient, API_ENDPOINTS } from '@shared/services';

/**
 * Interactor (Business Logic) for Newsletter Subscription
 * Handles the core business logic for newsletter subscription
 */
export const useNewsletterInteractor = () => {
  const [email, setEmail] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [message, setMessage] = useState({ type: '', text: '' });

  const subscribe = async (emailAddress) => {
    // Validation
    if (!emailAddress || !validateEmail(emailAddress)) {
      throw new Error(FORM_MESSAGES.error.invalidEmail);
    }

    // API call
    const response = await apiClient.post(API_ENDPOINTS.newsletter.subscribe, {
      email: emailAddress,
    });

    return response;
  };

  const handleSubscribe = async () => {
    setIsSubmitting(true);
    setMessage({ type: '', text: '' });

    try {
      await subscribe(email);
      setMessage({ type: 'success', text: FORM_MESSAGES.success.newsletter });
      setEmail('');
    } catch (error) {
      const errorMessage = error.message || FORM_MESSAGES.error.generic;
      setMessage({ type: 'error', text: errorMessage });
    } finally {
      setIsSubmitting(false);
    }
  };

  return {
    email,
    setEmail,
    isSubmitting,
    message,
    handleSubscribe,
  };
};
